<template>
  <div>
    <q-img
      v-if="this.ciudadSelected && this.ciudadSelected.file.length >0 && this.searchResource(this.ciudadSelected.file, 'imagen-logo')"
      class="Imagen"
      :src="this.searchResource(this.ciudadSelected.file, 'imagen-logo').url"
      :name="this.searchResource(this.ciudadSelected.file, 'imagen-logo').url"
      style="border-radius: 50%"
      />
      <q-select
        :class="'input'"
        data-cy="ciudades"
        outlined
        :options="optionsCiudades != null && optionsCiudades.length > 0 ? optionsCiudades : ['No hay opciones']"
        option-value="id"
        option-label="name"
        v-model="ciudadSelected"
        label="Municipios"
        :disable="optionsCiudades.length <= 1? true: disabled"
      >
      </q-select>
      <DialogWarning
        v-model="showDialog"
        dataCy="delete-indicador"
        :showIcon="true"
        :txtContainer="
          `Los datos introducidos no han sido guardados. Si abandona el proceso sin guardar se perderán todos los cambios.¿Desea salir del indicador?`
        "
        labelDelete="SÍ, SALIR Y PERDER TODOS LOS CAMBIOS"
        labelCancel="NO, PERMANECER EN EL INDICADOR"
        @save="saveChangesCitySelected"
      />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '../../storeModules/NGUD/types';
import Loading from '@/components/shared/mixins/Loading.js';
import DialogWarning from '@/shared/dialogs/warning/DialogWarning.vue';
import Resources from '@/components/shared/mixins/Resources.js';
import { QImg } from 'quasar';

export default {
  mixins: [Loading, Resources],
  components: {
    DialogWarning,
    QImg
  },
  props: {
    form_dirty: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      showDialog: false,
      val: null
    };
  },
  computed: {
    ciudadSelected: {
      get () {
        return this.$store.getters['NGUD/ciudadData'];
      },
      set (val) {
        this.val = val;
        if (this.form_dirty) {
          this.showDialog = true;
        } else {
          this.setCitySelected(val);
        }
      }
    },
    ...mapGetters({
      optionsCiudades: types.ALL_CIUDADES
    })
  },
  created () {
    if (this.$store.getters['NGUD/isAdmin']) {
      this.$store.dispatch(types.ACTION_GET_ALL_CIUDADES).then(response => {
        this.hideLoading();
        this.checkUsuarioCiudades(response);
      }).catch(() => { this.hideLoading(); });
    } else {
      this.$store.dispatch(types.ACTION_GET_ALL_CIUDADES_FILTERED, { idUser: this.$store.getters['NGUD/userId'] }).then(response => {
        this.hideLoading();
        this.checkUsuarioCiudades(response);
      }).catch(() => { this.hideLoading(); });
    }
  },
  methods: {
    setCitySelected (val) {
      // hay que hacer un get ciudad por id y entonces mutar la propiedad
      this.$store.dispatch(types.ACTION_GET_CIUDAD, { idCiudad: val.id }).then(response => {
        this.hideLoading();
        this.$store.commit('NGUD/setCiudadSelected', response.data);
        this.$emit('update');
      }).catch(() => { this.hideLoading(); });
      this.$eventHub.$emit('cleanForm');
    },
    closeDialog () {
      this.showDialog = false;
    },
    saveChangesCitySelected () {
      this.showDialog = false;
      this.setCitySelected(this.val);
    },
    checkUsuarioCiudades (response) {
      // si el usuario no tiene ciudades, redirigir a la pagina de error
      if (response.data.length === 0) {
        this.$router.push({ name: '401' });
      } else {
        // si tiene ciudades, comprobar si tiene una ciudad seleccionada, si no, seleccionar la primera disponible
        if (this.ciudadSelected === null) {
          this.$store.dispatch(types.ACTION_GET_CIUDAD, { idCiudad: response.data[0].id }).then(response => {
            this.hideLoading();
            this.$store.commit('NGUD/setCiudadSelected', response.data);
          }).catch(() => { this.hideLoading(); });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.input {
  background-color: #fff;
  border-radius: 10px;
}
label.q-field {
  width: 332px !important;
  margin-left: 15px;
}
@media (max-width: 640px) {
  ::v-deep {
    label.q-field {
      width: 232px !important;
    }
  }
}
.Imagen{
  height: 50px;
  width: 50px;
  float: left;
  margin-right: 12px;
  margin-left: 8px;
  background-color: white;
}
</style>
